var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGarland = function SvgGarland(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1269",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.054 123.28c96.743-4.044 181.47-27.593 253.82-76.476 8.687-4.995 13.684 5.471 7.854 9.396-94.601 61.609-156.12 73.741-260.84 79.093-8.21.357-7.021-11.656-.833-12.013z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1271",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m60.913 144.45 14.279-1.784-3.57 30.329H57.938z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1273",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m234.17 92.115 12.137-6.78 13.208 27.95-11.899 6.899z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1275",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m146.95 126.25 13.446-3.33 7.854 29.02-13.208 3.449z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1277",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.373 181.79h39.863v26.285c-14.16-4.163-27.369-4.044-39.863 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1279",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M63.174 311.67c26.536 0 48.312-21.646 48.312-48.288 0-26.523-21.776-48.169-48.312-48.169s-48.193 21.646-48.193 48.169c0 26.642 21.657 48.288 48.193 48.288"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1281",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m145.4 165.62 38.673-9.99 6.545 25.57c-14.755-.594-27.488 2.855-38.673 9.872z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1283",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M172.05 193.33c25.822-6.66 52.001 8.92 58.664 34.729s-8.925 51.975-34.746 58.636-52.12-8.92-58.664-34.729c-6.664-25.809 8.925-52.094 34.747-58.636z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path1285",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m242.38 133.5 35.103-18.911 12.494 23.193c-14.398 2.973-25.941 9.396-35.103 18.911z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path1287",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M274.87 155.27c23.442-12.726 52.715-3.925 65.447 19.506 12.613 23.43 3.808 52.689-19.634 65.296s-52.596 3.925-65.328-19.506c-12.613-23.43-3.927-52.689 19.515-65.296"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGarland);
export default ForwardRef;